<template>
  <el-card v-loading="loading">
    <el-header slot="header">
      <el-page-header @back="$router.back()" :content="`Manage ${role.display_name || role.name} Role`" />
    </el-header>

    <el-main>
      <section>
        <h4>Role</h4>

        <el-row>
          <el-col :span="24">
            <label>Name</label>
            <el-input 
              v-model="role.display_name" 
              :disabled="isSaving"
              placeholder="Foo Bar"
              maxlength="30"
              show-word-limit>
              <template slot="append">{{ role.name }}</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <label>Description</label>
            <el-input 
              v-model="role.description" 
              :disabled="isSaving"
              type="textarea" 
              placeholder="Foo Bar lets users.."
              maxlength="191">
              Description
            </el-input>
          </el-col>
        </el-row>
      </section>
      
      <section>
        <el-row>
          <el-col :span="24">
            <h4>Permission</h4>
            <el-divider/>

            <el-transfer
              v-model="role.permissions"
              :data="transferPermissions"
              :titles="['Available', 'Owned']">
            </el-transfer>
          </el-col>
        </el-row>
      </section>
    </el-main>

    <el-footer>
      <el-button type="primary" :loading="isSaving" @click="save">Save</el-button>
    </el-footer>
  </el-card>
</template>

<script>
  import axios, { RepositoryError } from '../../repositories';
  import { notify } from '../../utils';

  export default {
    name: 'ManageRole',
    async mounted() {
      this.loading = true;
      await Promise.all([
        this.fetch(),
        this.fetchPermissions(),
      ]);
      this.loading = false;
    },
    props: {
      role_id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        role: {
          name: '',
          display_name: '',
          description: '',
          permissions: [],
        },
        permissions: [],
        loading: false,
        isSaving: false,
      };
    },
    computed: {
      transferPermissions() {
        return this.permissions.map(permission => ({
          key: permission.name,
          label: permission.display_name || permission.name,
          disabled: this.isSaving,
        }));
      },
    },
    methods: {
      async fetch() {
        try {
          const response = await axios.get(`/auth/roles/${this.role_id}`);
          const data = response.data;

          this.role = data;
          this.role.permissions = data.permissions.map(permission => permission.name);
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        }
      },
      async fetchPermissions() {
        try {
          const response = await axios.get('/auth/permissions');
          
          this.permissions = response.data;
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        }
      },
      async save() {
        try {
          this.isSaving = true;

          await Promise.all([
            axios.put(`/auth/roles/${this.role_id}`, {
              name: this.role.name,
              display_name: this.role.display_name,
              description: this.role.description,
            }),
            axios.put(`/auth/role-permissions/${this.role_id}`, {
              permissions: this.role.permissions,
            })
          ]);
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.isSaving = false;
        }
      },
    },
    watch: {
      'role.display_name': function(display_name) {
        this.role.name = display_name.replace(' ', '-').toLowerCase();
      },
    },
  }
</script>
